import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert,
} from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen"; // For a professional icon

const LoginForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError(""); // Clear previous errors

    // --- Replace this with real authentication ---
    if (username === "TechnAdmin" && password === "Techn14112005") {
      localStorage.setItem("isAuthenticated", "true"); // simple auth flag
      navigate("/dashboard");
    } else {
      setError("Invalid username or password. Please try again.");
    }
  };

  return (
    // 1. Container: Centering the form on the screen
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f4f6f8", // Light admin background color
      }}
    >
      {/* 2. Paper: The main form card for a professional, elevated look */}
      <Paper
        elevation={8} // Higher elevation for a professional depth
        sx={{
          padding: 5,
          width: 400,
          borderRadius: 2, // Soft rounded corners
          backgroundColor: "#ffffff",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        {/* 3. Header and Icon */}
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <LockOpenIcon color="primary" sx={{ fontSize: 48, mb: 1 }} />
          <Typography variant="h5" component="h1" fontWeight="bold">
            Admin Panel Login
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Enter your credentials to access the dashboard.
          </Typography>
        </Box>

        {/* 4. Error Message (MUI Alert) */}
        {error && (
          <Alert severity="error" sx={{ mb: 1 }}>
            {error}
          </Alert>
        )}

        {/* 5. Form Submission */}
        <Box component="form" onSubmit={handleLogin} sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {/* Username Field */}
          <TextField
            fullWidth
            label="Username"
            variant="outlined"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          // Optional: Add an icon inside the input for better UX
          // InputProps={{ startAdornment: (<InputAdornment position="start"><PersonIcon /></InputAdornment>) }}
          />

          {/* Password Field */}
          <TextField
            fullWidth
            label="Password"
            variant="outlined"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          // InputProps={{ startAdornment: (<InputAdornment position="start"><KeyIcon /></InputAdornment>) }}
          />

          {/* Login Button */}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            color="primary"
            sx={{ mt: 1, py: 1.5, fontWeight: 'bold' }} // Custom padding and margin
          >
            Sign In
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default LoginForm;